<template>
  <div class="dld-wrap">
    <div class="dld-wrap-banner"></div>
    <ul>
      <li @click="handleNav">
        <div class="dld-wrap-flexbox">
          <van-image width="70" height="70" :src="require('../../assets/dld/img_o.png')"/>
        </div>
        <div class="dld-wrap-flexbox">
          <div class="dld-title">平安银行-车主贷 <van-image width="14" height="18" :src="require('../../assets/dld/icon_hot.png')"/></div>
          <div class="dld-lled">
            <span>年利率：<em>12-18%</em> </span>
            <span>额度 <em>3~50万</em></span>
          </div>
          <div class="dld-tags">
            <em>全款车抵押</em><em>不装GPS</em><em>等额本息</em>
          </div>
        </div>
      </li>
      <li @click="handleNav">
        <div class="dld-wrap-flexbox">
          <van-image width="70" height="70" :src="require('../../assets/dld/img_t.png')"/>
        </div>
        <div class="dld-wrap-flexbox">
          <div class="dld-title">平安银行-新一贷 <van-image width="14" height="18" :src="require('../../assets/dld/icon_hot.png')"/></div>
          <div class="dld-lled">
            <span>年利率：<em>12-18%</em> </span>
            <span>额度 <em>3~50万</em></span>
          </div>
          <div class="dld-tags">
            <em>无抵押</em><em>无担保</em><em>纯线上</em>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { Image as VanImage } from 'vant';
export default {
  data() {
    return {
      channel_lable: this.$route.params.channel_lable
    }
  },
  methods: {
    handleNav() {
      // console.log(this.$route.params.channel_lable)
      this.$router.push(`/loan?channel_lable=${this.channel_lable}`)
    }
  },
  components: {
    [VanImage.name]: VanImage
  }
}
</script>
